<template>
  <div class="log-item-detail">
    <p>ID <code>{{modelValue._id}}</code></p>
    <p>ID utente <code>user_id</code>: <a :class="`cursor-pointer${isChanged('user_id') ? ' font-weight-bold':''}`" @click="goToUserPage(modelValue.user_id)">{{displayUserId(modelValue.user_id)}}</a></p>
    <p>Valido dal <code>from</code>: <span :class="`${isChanged('from') ? ' font-weight-bold':''}`">{{formatDateTime(modelValue.from)}}</span></p>
    <p>Valido fino al <code>to</code>: <span :class="`${isChanged('to') ? ' font-weight-bold':''}`">{{formatDateTime(modelValue.to)}}</span></p>
    <p>N° giorni <code>num_days</code>: <span :class="`${isChanged('num_days') ? ' font-weight-bold':''}`">{{modelValue.num_days}}</span></p>
  </div>
</template>

<script lang="ts">
import {defineComponent, inject, type PropType} from 'vue'
import {type ExtraSeatsPause, SeatsType, type TopGymLogChangedField, type UserSeat} from "@/models.ts";
import type {Globals} from "@/plugins/globals.ts";
import utils from "@/utils";
import {useRouter} from "vue-router";
import {format} from "pathe";

export default defineComponent({
  name: "ExtraSeatPauseCard",
  methods: {format},
  props : {
    modelValue : {
      type : Object as PropType<ExtraSeatsPause>,
      required : true
    },
    changedFields : {
      type : Array as PropType<TopGymLogChangedField[]>
    }
  },
  setup(props, ctx) {

    const router = useRouter()
    const globals = inject('globals') as Globals

    return {
      displayUserId(id?:string):string {
        if(!id) return '-'
        const u = globals.users.value.find(u => u._id === id)
        return u ? `[${u._id}] ${u.surname} ${u.name} (${u.email})` : `[${id}] - utente eliminato`
      },
      async goToUserPage(id?:string) {
        if(!id) return
        const u = globals.users.value.find(u => u._id === id)
        if(!u) return
        await router.push(`/users/${id}`)
      },
      isChanged(attr:keyof ExtraSeatsPause):boolean {
        if(!props.changedFields || !props.changedFields.length) return false
        const i = props.changedFields.find(p => p.name === attr)
        return i !== undefined
      },
      formatDateTime : utils.formatDateTime
    }
  }
})
</script>

<style scoped>
.log-item-detail p {
  font-size: 12px;
  margin-top: 0;
  padding-bottom: 4px;
  margin-bottom: 4px;
  border-bottom: 1px solid #eee;
}

.log-item-detail p:has(> .font-weight-bold) {
  color: #dd0000;
}
.log-item-detail code {
  background-color: #dddddd;
  border-radius: 4px;
  padding: 2px 4px;
}
.log-item-detail a{
  text-decoration: underline;
  color: #f39530;
}
</style>